<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import { trans } from "laravel-vue-i18n";

defineProps({
    label: {
        type: String,
        default: "",
    },
    icon: {
        type: Object,
        default: null,
    },
    href: {
        type: String,
        default: "",
    },
});
</script>

<template>
    <Link
        :href="href"
        class="hover:bg-surface-700 flex w-48 items-center gap-x-3 px-6 py-5"
    >
        <Component
            :is="icon"
            class="h-6 w-6 fill-white"
        />

        <span class="font-light text-nowrap text-white">{{ trans(label) }}</span>
    </Link>
</template>
